import fr from 'facet-rest';
import Autocomplete from 'Components/UI/Autocomplete';

// eslint-disable-next-line import/prefer-default-export
export const MCSchedulerCalendarEventOverride = fr.metaOverride()
  .nameOverride('attendees', { _component: () => Autocomplete });
